<div class="home-page-container">
  <div class="erp-layout-wrapper">
    <!-- Minimal Enterprise Header -->
    <header class="erp-page-header">
      <div class="header-title-block">
        <h1 class="erp-title">Alimentos &amp; Bebidas</h1>
        <span class="erp-subtitle">Módulos</span>
      </div>
      <div class="header-summary-badge">
        <span class="summary-item">{{ totalMenusCount }} categorías</span>
        <span class="summary-sep">•</span>
        <span class="summary-item">{{ totalSubModulesCount }} módulos</span>
      </div>
    </header>

    <!-- Main Operational Work Centers (GESTIÓN & COCINA - 2 equal columns) -->
    <section class="erp-row-multi">
      <div
        *ngFor="let menuGroup of multiModuleMenus"
        class="erp-card-multi"
        [ngClass]="getMenuThemeClass(menuGroup.menu)"
      >
        <!-- Card Header -->
        <div class="card-multi-header">
          <div class="header-left">
            <div class="category-icon-box">
              <i-tabler
                [name]="getMenuIcon(menuGroup.menu)"
                class="category-icon"
              ></i-tabler>
            </div>
            <h2 class="category-title">{{ menuGroup.menu }}</h2>
          </div>
          <span class="category-badge">
            {{ menuGroup.subMenu?.length }} módulos
          </span>
        </div>

        <!-- Submodules List -->
        <div class="card-multi-body">
          <button
            type="button"
            *ngFor="let item of menuGroup.subMenu"
            class="action-item-row"
            (click)="navigateToRoute(item.route || '')"
            [attr.aria-label]="item.name"
          >
            <div class="item-info">
              <span class="item-icon-box">
                <i-tabler
                  [name]="item.icon || 'circle'"
                  class="item-icon"
                ></i-tabler>
              </span>
              <span class="item-name">{{ item.name }}</span>
            </div>

            <div class="item-meta">
              <code class="item-route">{{ item.route }}</code>
              <i-tabler name="chevron-right" class="item-chevron"></i-tabler>
            </div>
          </button>
        </div>
      </div>
    </section>

    <!-- Section Caption for Single Modules -->
    <div class="section-caption">
      <span class="caption-text">Accesos Directos</span>
      <div class="caption-line"></div>
    </div>

    <!-- Quick Access Direct Tiles (CUADRO PICNIC, REPORTES, ASIGNACIÓN DE MENÚS, PROVEEDORES - 4 equal columns) -->
    <section class="erp-row-single">
      <button
        type="button"
        *ngFor="let menuGroup of singleModuleMenus"
        class="erp-tile-single"
        [ngClass]="getMenuThemeClass(menuGroup.menu)"
        (click)="navigateToRoute(menuGroup.subMenu?.[0]?.route || '')"
        [attr.aria-label]="menuGroup.subMenu?.[0]?.name || menuGroup.menu"
      >
        <div class="tile-icon-box">
          <i-tabler
            [name]="menuGroup.subMenu?.[0]?.icon || getMenuIcon(menuGroup.menu)"
            class="tile-icon"
          ></i-tabler>
        </div>

        <div class="tile-content">
          <span class="tile-category">{{ menuGroup.menu }}</span>
          <span class="tile-name">{{ menuGroup.subMenu?.[0]?.name }}</span>
          <code class="tile-route">{{ menuGroup.subMenu?.[0]?.route }}</code>
        </div>

        <div class="tile-arrow">
          <i-tabler name="chevron-right" class="tile-chevron"></i-tabler>
        </div>
      </button>
    </section>
  </div>
</div>
